export { FechaModule } from './fecha.module';
export { Fecha } from './fecha.component';
export { reverseDate } from './reverse-date';
export { FechaDirective } from './fecha.directive';
